import "./ReportView.scss";

import React from "react";
//import { Link } from "react-router-dom";
//import request from "request"
import usesFeatures from "usesFeatures"
import moment from "moment"
import { flattenDeep } from "lodash"

import StoreReport from "./components/StoreReport"

import Icon from "Icon"
import Table from "Table"
import Header from "Header"

class ReportView extends React.Component {
  state = {
    entityType: window.location.pathname.includes("custom") ? "report" : "event",
  }

  componentDidMount() {
    const { computedMatch, match } = this.props
    const id = (computedMatch || match).params.reportId

    this.props.fetchData(`venue_admin/reports/${id}?entity_type=${this.state.entityType}`)
  }

  helpIcon = (hint, placement = "hint--top") => (
    <span className={`report-help ${placement} hint--large hint--rounded`} data-hint={hint}>
      <Icon icon="question-circle" style="solid" />
    </span>
  )

  renderCard = (size, title, data) => {
    return(
      <div className={`column ${size}`}>
        <div className="s-card">
          <h3>{ title }</h3>
          <h2>{ data }</h2>
        </div>
      </div>
    )
  }

  renderFooterRow = (name, data) => {
    return(
      <div className="columns">
        <h3 className="column is-one-half">{ name }</h3>
        <h2 className="column">{ data }</h2>
      </div>
    )
  }

  renderFooterTableRow = (name, data, nested = false) => {
    return(
      <tr>
        <td className={`${nested ? "pl-6" : ""}`}>{ name }</td>
        <td className="has-text-right">{ data }</td>
      </tr>
    )
  }

  render() {
    if (!this.props.dataFetched) return false

    const { event, categories, stores, data, dataWarning, showTax, hasGratuity, hasPrepaidCredits, downloadUrl } = this.props
    const { entityType } = this.state

    return(
      <div className="ReportView">
        <Header
          backLink="/reports"
          text={entityType === "report" ? event.name : `Report for ${event.name} - ${moment(event.date).format("MMM Do YYYY")}`}
          actions={true}
        >
          <a className="button is-primary" href={downloadUrl}>
            Download Sales CSV
          </a>
        </Header>
        { dataWarning &&
          <div className="message is-warning p-2">
            <p>
              <strong className="mr-2">Warning</strong>
              { entityType == "report" ? (
                <span>This report covers today, or future dates. The data may still be updating.</span>
              ) : (
                <span>
                  This event is still in progress, and there are still open stores.
                  It's possible this data is not completely accurate
                </span>
              )}
            </p>
          </div>
        }
        <div>
          <div className="Stats columns">
            <div className="column accounting is-half">
              <div className="s-card">

                <h3>Total Sales</h3>
                <h2>{data.sales || 0.00}</h2>

                <h3>Total Tips</h3>
                <h2>{data.tips || 0.00}</h2>

                { hasGratuity &&
                  <>
                    <h3>Total Gratuity { this.helpIcon(GRATUITY_HINT) }</h3>
                    <h2>{data.gratuities || 0.00}</h2>
                  </>
                }

                <h3>Partial Refunds</h3>
                <h2>({ data.refunded })</h2>

                { showTax &&
                  <>
                    <h3>Sales Tax Collected</h3>
                    <h2>{data.tax}</h2>

                    <h3>Sales Tax Refunded</h3>
                    <h2>({data.refundedTax})</h2>
                  </>
                }
                { data.discounts != "$0.00" &&
                  <>
                    <h3>Discounts</h3>
                    <h2>({data.discounts})</h2>
                  </>
                }
                <div className="summary">
                  <h3>Grand Total { hasGratuity && this.helpIcon(TOTAL_HINT) }</h3>
                  <h2>{data.total}</h2>
                </div>
              </div>
            </div>
            <div className="column columns is-multiline">
              { this.renderCard("is-half", "Total Orders", data.orderCount)}
              { this.renderCard(
                "is-half",
                "Orders per Customer",
                data.customerCount ? (data.orderCount/data.customerCount).toFixed(2) : "Unknown"
              )}
              { this.renderCard("is-half", "Average Order Spend", data.avgSpend)}
              { this.renderCard("is-half", "Average Order Size", data.avgSize || "Unknown")}
            </div>
          </div>
          <div className="Stats columns">
            { this.renderCard("is-quarter", "Cancelled Orders", data.cancelledCount)}
            { this.renderCard("is-quarter", "Cancelled Total", data.cancelled)}
            { this.renderCard("is-quarter", "Customers Count", data.customerCount)}
            { this.renderCard("is-quarter", "New Customer Count", data.newCustomerCount)}
          </div>
        </div>

        <div className="ReportWrapper">
          <StoreReport
            entityType={entityType}
            entityId={event.id}
            renderCard={this.renderCard}
            showTax={showTax}
            hasGratuity={hasGratuity}
            hasPrepaidCredits={hasPrepaidCredits}
          />
        </div>

        <div className="Payments columns mt-4">
          <div className="column">
            <div className="s-card">
              <h3 className="title">Sales</h3>

              <table className="table is-hoverable is-fullwidth">
                <tbody>
                  { this.renderFooterTableRow("Gross Sales", data.sales) }
                  { this.renderFooterTableRow("Taxes", data.tax) }
                  { this.renderFooterTableRow("Tips", data.tips) }
                  { hasGratuity && this.renderFooterTableRow("Gratuity", data.gratuities) }
                  { this.renderFooterTableRow("Refunded (partial refunds)", `(${data.refunded})`) }
                  { this.renderFooterTableRow("Taxes Refunded", `(${data.refundedTax})`) }
                  { data.discounts != "$0.00" && this.renderFooterTableRow("Total Discounts", `(${data.discounts})`) }
                  { data.prepaidCredits != "$0.00" && this.renderFooterTableRow("Total Prepaid Credits", data.prepaidCredits) }
                  <tr className="is-selected">
                    <th>Total Sales { hasGratuity && this.helpIcon(TOTAL_HINT) }</th>
                    <th className="has-text-right">{ data.total }</th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          { data.hasAllInclusive &&
            <div className="column">
              <div className="s-card">
                <h3 className="title">All-Inclusive Sales</h3>
                <table className="table is-hoverable is-fullwidth">
                  <tbody>
                    { this.renderFooterTableRow("Total Sales", data.allInclusive.sales) }
                    { this.renderFooterTableRow("Total refunded (partial refunds)", `(${data.allInclusive.refunded})`) }
                    { this.renderFooterTableRow("Total All Inclusive Sales", data.allInclusive.total) }
                    { this.renderFooterTableRow("Catch Fees", `(${data.allInclusive.fees})`) }
                  </tbody>
                </table>
              </div>
            </div>
          }
          <div className="column">
            <div className="s-card">
              <h3 className="title">Payments</h3>
              <table className="table is-hoverable is-fullwidth">
                <tbody>
                  <tr>
                    <th colSpan="2">Mobile Orders</th>
                  </tr>
                  { this.renderFooterTableRow("Card", data.paymentTypes.mobile.card, true) }
                  { this.renderFooterTableRow("Fees", `(${data.paymentTypes.mobile.fees})`, true) }
                  <tr>
                    <th colSpan="2">Terminal Orders</th>
                  </tr>
                  { this.renderFooterTableRow("Card", data.paymentTypes.terminal.card, true) }
                  { this.renderFooterTableRow("Cash", data.paymentTypes.terminal.cash, true) }
                  { this.renderFooterTableRow("Fees", `(${data.paymentTypes.terminal.fees})`, true) }
                  <tr>
                    <th>Total Collected { hasGratuity && this.helpIcon(COLLECTED_HINT) }</th>
                    <td className="has-text-right">{ data.total }</td>
                  </tr>
                  { this.renderFooterTableRow("Total Fees", `(${data.fees})`) }
                  { data.discounts != "$0.00" && this.renderFooterTableRow("Total Discounts", `(${data.discounts})`) }
                  <tr className="is-selected">
                    <th>Net Total</th>
                    <th className="has-text-right">{ data.netTotal }</th>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
        </div>

      </div>
    )
  }
}

const GRATUITY_HINT =
  "Total gratuity charged to customers on their orders in this period — a service " +
  "charge that's separate from optional tips. It's already part of each order's total " +
  "the customer paid, so it's counted inside the Grand Total below, not added on top."

const TOTAL_HINT =
  "Gross sales plus tax, tips and gratuity, minus partial refunds and discounts. " +
  "Gratuity collected from customers is included in this total."

const COLLECTED_HINT =
  "Total money collected from customers: sales, tax, tips and gratuity, net of refunds. " +
  "Gratuity is included here."

export default usesFeatures(["data"], ReportView)
